import {flow} from "mobx-state-tree";

const poll = flow( function* poll( fn: any, fnCondition: Function, ms: number, waitMessage: string | null, maxRuns: number ) {
    let result = yield fn();
    let amountRan = 0;
    while ( fnCondition( result ) && amountRan <= maxRuns ) {
        yield wait( ms, waitMessage );
        result = yield fn();
        amountRan++;
    }
    return result;
} );

function wait( ms = 1000, waitMessage: string | null )
{
    return new Promise( resolve => {
        if ( waitMessage != null ) {
            console.log( waitMessage );
        }
        console.log( `waiting ${ms} ms...` );
        setTimeout( resolve, ms );
    } );
}

export default poll;
